export const products = [
  {
    name: "Raw Water Pumping",
    img: "assets/card-img/Raw Water Pumping.png",
    text:
      "This pump does the bulk of the engine's cooling. It draws raw water (this may be seawater, fresh water or whatever mixture of the two the boat is floating in) into the engine's open or raw-water cooling circuit using a rubber impeller.",
    position: {
      left: "17%",
      top: "43%"
    },
    id: "rwppg",
    scene: {
      src: "../../../assets/Raw-Water-Pumping/Scene-01.mp4",
      type: "video/mp4"
    },
    endScene: {
      src: "../../../assets/Raw-Water-Pumping/Scene-01-Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Raw-Water-Pumping/EndFrame.png",
    page: "pumping"
  },
  {
    name: "Cooling Towers",
    img: "assets/card-img/Cooling Towers.png",
    text:
      "Cooling tower is a specialized heat exchanger in which air and water are brought into direct contact with each other in order to reduce the water's temperature. As this occurs, a small volume of water is evaporated, reducing the temperature of the water being circulated through the tower.",
    id: "clts",
    position: {
      left: "23.5%",
      bottom: "40%"
    },
    scene: {
      src: "../../../assets/Cooling-tower/Scene09.mp4",
      type: "video/mp4"
    },
    page: "cooling",
    endScene: {
      src: "../../../assets/Cooling-tower/Scene09Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Cooling-tower/EndFrame.png"
  },
  {
    name: "Effluent Collection Pit",
    img: "assets/card-img/Effluent Collection Pit.png",
    text:
      "Effluent Collection Pit have septic tanks that collect sewage from residences and businesses, and the effluent that comes out of the tank is sent to either a centralized sewage treatment plant or a distributed treatment system for further treatment.",
    id: "ecft",
    position: {
      left: "36%",
      bottom: "24%"
    },
    scene: {
      src: "../../../assets/EffluentCollection/Scen.mp4",
      type: "video/mp4"
    },
    page: "collectionpit",
    endScene: {
      src: "../../../assets/EffluentCollection/SceneReverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/EffluentCollection/EndFrame.png"
  },
  {
    name: "Effluent Water Treatment Plant",
    img: "assets/card-img/Effluent_Water_Treatment.png",
    text:
      "Effluent water treatment plant is the process of removing contaminants from municipal wastewater, containing mainly household sewage plus some industrial wastewater.",
    id: "ewtp",
    position: {
      left: "36.5%",
      bottom: "41%"
    },
    scene: {
      src: "../../../assets/Effluent-Treatment-Plant/Scene-03.mp4",
      type: "video/mp4"
    },
    page: "effluentplant",
    endScene: {
      src: "../../../assets/Effluent-Treatment-Plant/Scene--Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../assets/Effluent-Treatment-Plant/EndFrame.png"
  },
  {
    name: "Raw Water Transfer",
    img: "assets/card-img/Raw Water Transfer.png",
    text:
      "Overhead Water Storage Tank is a usual Water storage tank as its name stands for itself these tanks are placed over the head that is built on a certain height. The water from the ground level is filled inside the tank through pumping.",
    id: "rwtf",
    position: {
      left: "26%",
      top: "40%"
    },
    scene: {
      src: "../../../assets/Raw-Water-Transfer/Scene02.mp4",
      type: "video/mp4"
    },
    page: "transfer",
    endScene: {
      src: "../../../assets/Raw-Water-Transfer/Scene02Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Raw-Water-Transfer/EndFrame.png"
  },
  {
    name: "Softner",
    img: "assets/card-img/Softner.png",
    text:
      "Water softening is the removal of calcium, magnesium, and certain other metal cations in hard water. The resulting soft water requires less soap for the same cleaning effort, as soap is not wasted bonding with calcium ions.",
    id: "sftnr",
    position: {
      left: "31.5%",
      top: "38%"
    },
    scene: { src: "../../../assets/Softener/Scene04.mp4", type: "video/mp4" },
    page: "softner",
    endScene: {
      src: "../../../assets/Softener/Scene04Reverse.mp4",
      type: "video/mp4"
    },
    productImage: ".../../../assets/Softener/EndFrame.png"
  },
  {
    name: "RO/DM Plant",
    img: "assets/card-img/RO Plant.png",
    text:
      "RO and DI filters use different physical reactions to clean water. Reverse Osmosis (RO) is often used to partially clean-up tap water to make it roughly 90% to 99% pure. Deionization (DI) filters exchange positive hydrogen and negative hydroxyl molecules for positive and negative contaminant molecules in water.",
    id: "rodm",
    position: {
      left: "33%",
      top: "32%"
    },
    scene: {
      src: "../../../assets/RO_D-plant/Scene-05.mp4",
      type: "video/mp4"
    },
    page: "plant",
    endScene: {
      src: "../../../assets/RO_D-plant/Scene 05 Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/RO_D-plant/End Frame.png"
  },
  {
    name: "Fire Fighting Equipment",
    img: "assets/card-img/Fire Fighting Equipment.png",
    text:
      "Technical equipment designed to rescue people and protect valuable goods and natural resources from fire.",
    id: "ffet",
    position: {
      left: "44%",
      top: "47.5%"
    },
    scene: {
      src: "../../../assets/FireEquipment/Scene14.mp4",
      type: "video/mp4"
    },
    page: "fire",
    endScene: {
      src: "../../../assets/FireEquipment/SceneReverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/FireEquipment/EndFrame.png"
  },
  {
    name: "Product Storage Tanks",
    img: "assets/card-img/Product Storage Tank.png",
    text:
      "Storage tanks are containers that hold liquids, compressed gases or mediums used for the short- or long-term storage of heat or cold.",
    id: "pstk",
    position: {
      right: "47.5%",
      bottom: "41%"
    },
    scene: {
      src: "../../../assets/ProductStorageTank/Scene16.mp4",
      type: "video/mp4"
    },
    page: "productstorage",
    endScene: {
      src: "../../../assets/ProductStorageTank/Scene16Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/ProductStorageTank/EndFrame.png"
  },
  {
    name: "Loading Area",
    img: "assets/card-img/Loading Area.png",
    text:
      "A loading dock or loading bay is an area of a building where goods vehicles (usually road or rail) are loaded and unloaded. They are commonly found on commercial and industrial buildings, and warehouses in particular.",
    id: "ldar",
    position: {
      left: "54%",
      bottom: "38%"
    },
    scene: { src: "../../../assets/Loading/Scene17.mp4", type: "video/mp4" },
    page: "loading",
    endScene: {
      src: "../../../assets/Loading/SceneReverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Loading/EndFrame.png"
  },
  {
    name: "Heat Exchangers",
    img: "assets/card-img/Heat Transfer.png",
    text:
      "Heat exchanger is a system used to transfer heat between two or more fluids. Heat exchangers are used in both cooling and heating processes. The fluids may be separated by a solid wall to prevent mixing or they may be in direct contact.",
    id: "hexc",
    position: {
      right: "43%",
      bottom: "47%"
    },
    scene: {
      src: "../../../assets/Heat-Exchanger/Scene-07.mp4",
      type: "video/mp4"
    },
    page: "heatexchange",
    endScene: {
      src: "../../assets/Heat-Exchanger/Scene-07-Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../assets/Heat-Exchanger/End-Frame.png"
  },
  {
    name: "Chillers",
    img: "assets/card-img/Chillers.png",
    text:
      "Chiller is a machine that removes heat from a liquid via a vapor-compression, Adsorption refrigeration, or absorption refrigeration cycles. This liquid can then be circulated through a heat exchanger to cool equipment, or another process stream (such as air or process water).",
    id: "chill",
    position: {
      right: "45%",
      top: "44.5%"
    },
    scene: { src: "../../../assets/Chillers/Scene-06.mp4", type: "video/mp4" },
    page: "chillers",
    endScene: {
      src: "../../../assets/Chillers/Scene-Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Chillers/EndFrame.png"
  },
  {
    name: "Machine Jacket Cooling",
    img: "assets/card-img/Machine Jacket Cooling.png",
    text:
      "A water jacket is a water-filled casing surrounding a device, typically a metal sheath having intake and outlet vents to allow water to be pumped through and circulated. The flow of water to an external heating or cooling device allows precise temperature control of the device.",
    id: "mjcg",
    position: {
      left: "47%",
      top: "43%"
    },
    scene: {
      src: "../../../assets/MachineJacketCooling/Scene12.mp4",
      type: "video/mp4"
    },
    page: "jacketcooling",
    endScene: {
      src: "../../../assets/MachineJacketCooling/SceneReverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/MachineJacketCooling/EndFrame.png"
  },
  {
    name: "Canteen / Restrooms",
    img: "assets/card-img/Canteen_Utility.png",
    text:
      "A restaurant attached to a factory, school, etc. providing meals for large numbers of people, also provides limited range of items, such as toilet requisites.",
    id: "crts",
    position: {
      left: "48%",
      top: "31%"
    },
    scene: {
      src: "../../../assets/Canteenrestroom/Scene15.mp4",
      type: "video/mp4"
    },
    page: "restroom",
    endScene: {
      src: "../../../assets/Canteenrestroom/Scene15Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Canteenrestroom/EndFrame.png"
  },
  {
    name: "Reactor Vessels",
    img: "assets/card-img/Reactor Vessel.png",
    text:
      "Reactor pressure vessels, which contain the nuclear fuel that powers the reactor core in nuclear power plants, are made of cylindrical shell courses with a welded hemispherical bottom head and a removable hemispherical upper head.",
    id: "rvess",
    position: {
      right: "38%",
      bottom: "44%"
    },
    scene: {
      src: "../../../assets/Reactor-Vessels/Scene10.mp4",
      type: "video/mp4"
    },
    page: "reactor",
    endScene: {
      src: "../../../assets/Reactor-Vessels/Scene10Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Reactor-Vessels/End-Frame.png"
  },
  {
    name: "Boilers",
    img: "assets/card-img/Boilers.png",
    text:
      "A boiler is a closed vessel in which fluid (generally water) is heated. The fluid does not necessarily boil. The heated or vaporized fluid exits the boiler for use in various processes or heating applications,[1][2] including water heating, central heating, boiler-based power generation, cooking, and sanitation.",
    id: "boil",
    position: {
      right: "34%",
      top: "47%"
    },
    scene: { src: "../../../assets/Boiler/Scene-08.mp4", type: "video/mp4" },
    page: "boiler",
    endScene: {
      src: "../../../assets/Boiler/Scene-08-Reverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Boiler/End-Frame.png"
  },
  {
    name: "Raw Materials - Storage Tank",
    img: "assets/card-img/Storage Tank - Raw Materials.png",
    text:
      "Storage tanks are containers that hold liquids, compressed gases  or mediums used for the short- or long-term storage of heat or cold.",
    id: "strm",
    position: {
      right: "29%",
      bottom: "54%"
    },
    scene: {
      src: "../../../assets/Storage-Tanks/scene11.mp4",
      type: "video/mp4"
    },
    page: "storageraw",
    endScene: {
      src: "../../../assets/Storage-Tanks/sceneReverse.mp4",
      type: "video/mp4"
    },
    productImage: "../../../assets/Storage-Tanks/EndFrame.png"
  },
];
